<template>
  <v-dialog
    v-model="isOpenModal"
    transition="slide-x-transition"
    :scrim="false"
    :fullscreen="$vuetify.breakpoint.mobile"
    :width="$vuetify.breakpoint.mobile ? '' : '80%'"
    @click:outside="onClose"
  >
    <v-card class="left-vertical-card bg-titre">
      <div class="d-flex pt-4 pl-3">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          <v-icon
            size="28"
            color="secondary"
          >
            mdi-account-multiple-outline
          </v-icon> Groupe de comparaison
        </div>

        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <BaseErrorMessage
        v-if="erreur.updateFiltres"
        message="Erreur serveur. merci de réessayer plus tard."
      />
      <div
        v-if="!erreur.updateFiltres"
        class="pb-16 pb-md-0"
      >
        <v-row
          class="mt-6 mx-1"
          no-gutters
        >
          <v-col
            cols="12"
            md="4"
            class="px-3"
            @click="onAnyClickFiltres"
          >
            <AgrialSelect
              v-model="regionAgrialSelected"
              :class="regionAgrialSelected.length > 1 ? 'input-multiple' : 'pt-1'"
              :disabled="loading.updateFiltres"
              :clearable="abonnements.culturialAbonne"
              :hide-details="regionAgrialSelected.length < 1"
              :items="filtresValeursPossibles.regionsAgrial"
              :readonly="!abonnements.culturialAbonne"
              :menu-props="{ top: true, offsetY: true }"
              item-text="libelle"
              label="Régions Agrial"
              multiple
              return-object
            >
              <template
                v-if="!abonnements.culturialAbonne"
                v-slot:prepend-inner
              >
                <v-icon
                  class="prepend-icon"
                  size="18"
                  color="var(--gris-clair)"
                >
                  mdi-lock
                </v-icon>
              </template>
            </AgrialSelect>
            <div
              v-if="regionAgrialSelected.length<1"
              class="px-3 pb-5 red--text"
            >
              Au moins une région doit être sélectionnée
            </div>
          </v-col>
          <v-col
            v-if="regionAgrialSelected.length>=3"
            cols="auto"
            class="mb-5 mb-md-0 px-2 px-md-0"
          >
            <BaseMessageV2 message="Le chargement des comparaisons augmente avec le nombre de régions sélectionnées" />
          </v-col>
        </v-row>
        <div
          class="d-flex  mx-1"
          :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between mt-6'"
          no-gutters
        >
          <div
            class=" px-3"
            :class="$vuetify.breakpoint.mobile ? '' : 'w-300'"
            @click="onAnyClickFiltres"
          >
            <AgrialSelect
              v-model="typeExploitationSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.typeExploitation"
              :readonly="!abonnements.culturialAbonne"
              item-text="libelle"
              label="Type d'exploitation"
              return-object
              class="pt-1"
              @change="loadRepartitionTypeExploitation"
            >
              <template
                v-if="!abonnements.culturialAbonne"
                v-slot:prepend-inner
              >
                <v-icon
                  class="prepend-icon"
                  size="18"
                  color="var(--gris-clair)"
                >
                  mdi-lock
                </v-icon>
              </template>
            </AgrialSelect>
          </div>
          <div
            class=" px-3"
            :class="$vuetify.breakpoint.mobile ? '' : 'w-300'"
            @click="onAnyClickFiltres"
          >
            <AgrialSelect
              v-model="typeProductionSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.typeProduction"
              :readonly="!abonnements.culturialAbonne"
              item-text="libelle"
              label="Type de production"
              return-object
              class="pt-1"
              @change="loadRepartitionTypeProduction"
            >
              <template
                v-if="!abonnements.culturialAbonne"
                v-slot:prepend-inner
              >
                <v-icon
                  class="prepend-icon"
                  size="18"
                  color="var(--gris-clair)"
                >
                  mdi-lock
                </v-icon>
              </template>
            </AgrialSelect>
          </div>
          <div
            class=" px-3"
            :class="$vuetify.breakpoint.mobile ? '' : 'w-300'"
            @click="onAnyClickFiltres"
          >
            <AgrialSelect
              v-model="potentielSolSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.potentielSol"
              :readonly="!abonnements.culturialAbonne"
              item-text="libelle"
              label="Potentiel de sol"
              return-object
              class="pt-1"
              @change="loadRepartitionPotentielSol"
            >
              <template
                v-if="!abonnements.culturialAbonne"
                v-slot:prepend-inner
              >
                <v-icon
                  class="prepend-icon"
                  size="18"
                  color="var(--gris-clair)"
                >
                  mdi-lock
                </v-icon>
              </template>
            </AgrialSelect>
          </div>
          <div
            class=" px-3"
            :class="$vuetify.breakpoint.mobile ? '' : 'w-300'"
            @click="onAnyClickFiltres"
          >
            <AgrialSelect
              v-model="ressourceEffluentSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.ressourceEffluents"
              :readonly="!abonnements.culturialAbonne"
              item-text="libelle"
              label="Ressource en effluents"
              return-object
              class="pt-1"
              @change="loadRepartitionRessourceEffluent"
            >
              <template
                v-if="!abonnements.culturialAbonne"
                v-slot:prepend-inner
              >
                <v-icon
                  class="prepend-icon"
                  size="18"
                  color="var(--gris-clair)"
                >
                  mdi-lock
                </v-icon>
              </template>
            </AgrialSelect>
          </div>
          <div
            class=" px-3"
            :class="$vuetify.breakpoint.mobile ? '' : 'w-300'"
            @click="onAnyClickFiltres"
          >
            <AgrialSelect
              v-model="stockeurSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.stockeur"
              :readonly="!abonnements.culturialAbonne"
              item-text="libelle"
              label="Stockeur"
              return-object
              class="pt-1"
              @change="loadRepartitionStockeur"
            >
              <template
                v-if="!abonnements.culturialAbonne"
                v-slot:prepend-inner
              >
                <v-icon
                  class="prepend-icon"
                  size="18"
                  color="var(--gris-clair)"
                >
                  mdi-lock
                </v-icon>
              </template>
            </AgrialSelect>
          </div>
        </div>
        <v-row class="mx-1">
          <v-col
            cols="12"
            md="4"
          >
            <RepartitionParametre
              titre="Type d'exploitation"
              :selected="typeExploitationSelected"
              :referentiel="filtresValeursPossibles.typeExploitation"
              :repartition="repartitionParametresTypeExploitation"
              :loading="loading.updateTypeExploitation"
              :erreur="erreur.updateTypeExploitation"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <RepartitionParametre
              titre="Type de production"
              :selected="typeProductionSelected"
              :referentiel="filtresValeursPossibles.typeProduction"
              :repartition="repartitionParametresTypeProduction"
              :loading="loading.updateTypeProduction"
              :erreur="erreur.updateTypeProduction"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <RepartitionParametre
              titre="Potentiel de sol"
              :selected="potentielSolSelected"
              :referentiel="filtresValeursPossibles.potentielSol"
              :repartition="repartitionParametresPotentielSol"
              :loading="loading.updatePotentielSol"
              :erreur="erreur.updatePotentielSol"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <RepartitionParametre
              titre="Ressource en effluents"
              :selected="ressourceEffluentSelected"
              :referentiel="filtresValeursPossibles.ressourceEffluents"
              :repartition="repartitionParametresRessourceEffluent"
              :loading="loading.updateRessourceEffluent"
              :erreur="erreur.updateRessourceEffluent"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-16 mb-md-0"
          >
            <RepartitionParametre
              titre="Stockeur"
              :selected="stockeurSelected"
              :referentiel="filtresValeursPossibles.stockeur"
              :repartition="repartitionParametresTypeStockage"
              :loading="loading.updateStockeur"
              :erreur="erreur.updateStockeur"
            />
          </v-col>
        </v-row>
        <v-row
          :class="$vuetify.breakpoint.mobile ? 'fixed-btn-actions pa-3' : 'px-5 pb-5 mt-2'"
          no-gutters
          :justify="$vuetify.breakpoint.mobile ? 'center' : 'end'"
        >
          <v-col
            cols="6"
            md="2"
            class="pr-2"
          >
            <BaseButton
              :is-loading="loading.updateFiltres"
              libelle-btn="Annuler"
              @click="onClose"
            />
          </v-col>
          <v-col
            cols="6"
            md="2"
          >
            <BaseButton
              :is-disabled="regionAgrialSelected.length<1"
              :is-loading="loading.updateFiltres"
              is-color-branche
              libelle-btn="Valider"
              @click="onValider"
            />
          </v-col>
        </v-row>
      </div>

      <InformationAbonnementModal
        v-if="isOpenModalInformationAbonnement"
        :is-open-modal-information-abonnement="isOpenModalInformationAbonnement"
        code-feature="FILTRE_COMPARAISON"
        texte="Affinez vos comparaisons en choisissant le type d'exploitation avec lequel vous souhaitez vous comparer."
        titre="Filtres de comparaison"
        @close="isOpenModalInformationAbonnement = false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import AgrialSelect from '@/components/form/agrial-select.vue'
import BaseButton from '@/components/common/base-button.vue'
import BaseErrorMessage from '@/components/common/base-error-message.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import BaseMessageV2 from '@/components/common/base-message-v2.vue'
import RepartitionParametre from '@/views/groupe-comparaison/components/repartition-parametre.vue'

export default {
  name: 'FiltreComparaisonModal',
  components: {AgrialSelect, BaseButton, BaseErrorMessage, BaseMessageV2, InformationAbonnementModal, RepartitionParametre},
  props: {
    isOpenModalFiltres: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: {
        updateFiltres: false,
        updateTypeExploitation: false,
        updateTypeProduction: false,
        updatePotentielSol: false
      },
      erreur: {
        updateFiltres: false,
        updateTypeExploitation: false,
        updateTypeProduction: false,
        updatePotentielSol: false
      },
      regionAgrialSelected: null,
      typeExploitationSelected: null,
      typeProductionSelected: null,
      potentielSolSelected: null,
      ressourceEffluentSelected: null,
      stockeurSelected: null,
      isOpenModalInformationAbonnement: false,
      isOpenModal: false
    }
  },

  computed: {
    ...mapGetters({
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      filtresValeursPossibles: 'filtresComparaison/filtresValeursPossibles',
      abonnements: 'adherent/abonnements',
      // Ces cinq repartitions etaient lues par les composants eux-memes. Le
      // composant generique RepartitionParametre etant purement presentatif,
      // c'est desormais ce parent - qui sait de quelle repartition il s'agit -
      // qui les fournit en props.
      repartitionParametresTypeExploitation: 'parametresExploitationGroupe/repartitionParametresTypeExploitation',
      repartitionParametresTypeProduction: 'parametresExploitationGroupe/repartitionParametresTypeProduction',
      repartitionParametresPotentielSol: 'parametresExploitationGroupe/repartitionParametresPotentielSol',
      repartitionParametresRessourceEffluent: 'parametresExploitationGroupe/repartitionParametresRessourceEffluent',
      repartitionParametresTypeStockage: 'parametresExploitationGroupe/repartitionParametresTypeStockage'
    }),
  },

  created () {
    this.resetAllSelects()
    this.loadRepartitionTypeExploitation()
    this.loadRepartitionTypeProduction()
    this.loadRepartitionPotentielSol()
    this.loadRepartitionRessourceEffluent()
    this.loadRepartitionStockeur()
    this.isOpenModal = this.isOpenModalFiltres
    this.fetchAbonnements()
    
  },

  methods: {
    ...mapActions({
      setFiltres: 'filtresComparaison/setFiltres',
      fetchAbonnements: 'adherent/fetchAbonnements',
      getRepartitionTypeExploitationGroupe: 'parametresExploitationGroupe/getRepartitionTypeExploitationGroupe',
      getRepartitionTypeProductionGroupe: 'parametresExploitationGroupe/getRepartitionTypeProductionGroupe',
      getRepartitionPotentielSolGroupe: 'parametresExploitationGroupe/getRepartitionPotentielSolGroupe',
      getRepartitionRessourceEffluentGroupe: 'parametresExploitationGroupe/getRepartitionRessourceEffluentGroupe',
      getRepartitionTypeStockageGroupe: 'parametresExploitationGroupe/getRepartitionTypeStockageGroupe',
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement'
    }),

    updateFiltresAdherent () {
      this.loading.updateFiltres = true
      this.erreur.updateFiltres = false

      const filtresAUpdate = {
        typeExploitation: this.typeExploitationSelected,
        typeProduction: this.typeProductionSelected,
        potentielSol: this.potentielSolSelected,
        ressourceEffluents: this.ressourceEffluentSelected,
        stockeur: this.stockeurSelected,
        regionsAgrial: this.regionAgrialSelected,
      }
      return this.setFiltres(filtresAUpdate)
        .then(() => this.resetAllSelects())
        .catch(() => this.erreur.updateFiltres = true)
        .finally(() => this.loading.updateFiltres = false)
    },

    resetAllSelects () {
      this.typeExploitationSelected = this.filtresAdherent.typeExploitation
      this.typeProductionSelected = this.filtresAdherent.typeProduction
      this.potentielSolSelected = this.filtresAdherent.potentielSol
      this.ressourceEffluentSelected = this.filtresAdherent.ressourceEffluents
      this.stockeurSelected = this.filtresAdherent.stockeur
      this.regionAgrialSelected = this.filtresAdherent.regionsAgrial
    },
    onValider () {
      if (!this.abonnements.culturialAbonne) {
        this.$emit('close')
      } else {
        this.updateFiltresAdherent()
        this.$emit('update')
      }
    },
    onClose () {
      this.$emit('close')
    },
    onAnyClickFiltres () {
      if (!this.abonnements.culturialAbonne) {
        this.isOpenModalInformationAbonnement = !this.isOpenModalInformationAbonnement
        this.incrementerAccesSouscriptionAbonnement('FILTRE_COMPARAISON')
      }
    },
    loadRepartitionTypeExploitation () {
      this.loading.updateTypeExploitation = true
      this.erreur.updateTypeExploitation = false
      this.getRepartitionTypeExploitationGroupe(this.filtresAdherent.regionsAgrial.map(r =>r.codeRegion))
        .catch(() => {
          this.erreur.updateTypeExploitation = true
        })
        .finally(() => {
          this.loading.updateTypeExploitation = false
        })
    },
    loadRepartitionTypeProduction () {
      this.loading.updateTypeProduction = true
      this.erreur.updateTypeProduction = false
      this.getRepartitionTypeProductionGroupe(this.filtresAdherent.regionsAgrial.map(r =>r.codeRegion))
        .catch(() => {
          this.erreur.updateTypeProduction = true
        })
        .finally(() => {
          this.loading.updateTypeProduction = false
        })
    },
    loadRepartitionPotentielSol () {
      this.loading.updatePotentielSol = true
      this.erreur.updatePotentielSol = false
      this.getRepartitionPotentielSolGroupe(this.filtresAdherent.regionsAgrial.map(r =>r.codeRegion))
        .catch(() => {
          this.erreur.updatePotentielSol = true
        })
        .finally(() => {
          this.loading.updatePotentielSol = false
        })
    },
    loadRepartitionRessourceEffluent () {
      this.loading.updateRessourceEffluent = true
      this.erreur.updateRessourceEffluent = false
      this.getRepartitionRessourceEffluentGroupe(this.filtresAdherent.regionsAgrial.map(r =>r.codeRegion))
        .catch(() => {
          this.erreur.updateRessourceEffluent = true
        })
        .finally(() => {
          this.loading.updateRessourceEffluent = false
        })
    },
    loadRepartitionStockeur () {
      this.loading.updateStockeur = true
      this.erreur.updateStockeur = false
      this.getRepartitionTypeStockageGroupe(this.filtresAdherent.regionsAgrial.map(r =>r.codeRegion))
        .catch(() => {
          this.erreur.updateStockeur = true
        })
        .finally(() => {
          this.loading.updateStockeur = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
  background-color: #f1f2f5;

  .fixed-btn-actions {
    background-color: white;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.w-300 {
  width: 300px;
}

.prepend-icon {
  z-index: 100;
}

.input-multiple {
  height: 60px !important;
  overflow-y: scroll;
  padding-top: 5px;
}

</style>
